import React from 'react';
import moment from 'moment';

export function TransfersDateColumnFormatter(cellContent) {

  return (
    <div className="d-block text-nowrap" style={{ color: '#333', fontSize: '16px' }}>
       {cellContent ? moment(cellContent).format('DD-MM-YYYY') : ''}
    </div>
  );
}
